import { render, staticRenderFns } from "./single-modal.vue?vue&type=template&id=61a15a4e&scoped=true&"
import script from "./single-modal.vue?vue&type=script&lang=js&"
export * from "./single-modal.vue?vue&type=script&lang=js&"
import style0 from "./single-modal.vue?vue&type=style&index=0&id=61a15a4e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61a15a4e",
  null
  
)

export default component.exports